/**
 * @flow
 */
import Grid from '@mui/material/Grid';
import DrawerTitle from 'components/@whistleblower-admin/drawers/OccurrenceDrawer/DrawerTitle';
import OccurrenceContext from 'components/@whistleblower-admin/drawers/OccurrenceDrawer/OccurrenceContext';
import OccurrenceDetails from 'components/@whistleblower-admin/drawers/OccurrenceDrawer/OccurrenceDetails';
import OccurrenceMessages from 'components/@whistleblower-admin/drawers/OccurrenceDrawer/OccurrenceMessages';
import OccurrenceTools from 'components/@whistleblower-admin/drawers/OccurrenceDrawer/OccurrenceTools';
import { useDrawer } from 'components/common/Drawer/DrawerContext';
import React, { useCallback, useEffect } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useSaveOccurrenceMutation } from 'store/app/entities/WbSlice';

const styles = {
  root: { width: '80vw', position: 'relative' },
  left: {
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
  },
};

const getDefaultValues = occurrence => {
  const { category, severity = '', status, closingCode, closingComment } = occurrence;
  return { category, severity, status, closingCode, closingComment };
};

const OccurrenceDrawerContent = () => {
  const { state: occurrence, setTitle, setOnSubmit } = useDrawer('OccurrenceDrawer');
  const methods = useForm({ defaultValues: getDefaultValues(occurrence) });
  const [save] = useSaveOccurrenceMutation();
  const onSubmit = useCallback(
    async body => {
      await save({ id: occurrence._id, body });
    },
    [occurrence._id, save],
  );
  useEffect(() => {
    setOnSubmit(methods.handleSubmit(onSubmit));
  }, [methods, onSubmit, setOnSubmit]);
  useEffect(() => {
    setTitle(<DrawerTitle title={occurrence.title} number={occurrence.number} />);
  }, [occurrence.number, occurrence.title, setTitle]);
  return (
    <OccurrenceContext.Provider value={occurrence}>
      <FormProvider {...methods}>
        <Grid container sx={styles.root} spacing={4}>
          <Grid sx={styles.left} size={7}>
            <OccurrenceDetails />
            <OccurrenceMessages />
          </Grid>
          <Grid sx={{ pt: 0 }} size={5}>
            <OccurrenceTools />
          </Grid>
        </Grid>
      </FormProvider>
    </OccurrenceContext.Provider>
  );
};
export default OccurrenceDrawerContent;
